import React from "react";
import {
  Home,
  Building2,
  Hotel,
  Hospital,
  Plane,
  School,
  Dumbbell,
  LayoutGrid,
  ShoppingCart,
  Factory,
} from "lucide-react";

const recommendations = [
  { icon: <Home size={40} />, label: "RESIDENTIAL" },
  { icon: <Building2 size={40} />, label: "COMMERCIAL BUILDING" },
  { icon: <Hotel size={40} />, label: "HOTEL, RESTAURANT" },
  { icon: <Hospital size={40} />, label: "HOSPITAL" },
  { icon: <Plane size={40} />, label: "AIRPORT" },
  { icon: <School size={40} />, label: "SCHOOL, COLLEGE" },
  { icon: <Dumbbell size={40} />, label: "GYMNASIUM" },
  { icon: <LayoutGrid size={40} />, label: "HALL & CORRIDOR" },
  { icon: <ShoppingCart size={40} />, label: "MALL & SUPER MARKET" },
  { icon: <Factory size={40} />, label: "INDUSTRY" },
];

const Recommendations = () => {
  return (
    <div className="py-12 px-4 text-center max-w-[1200px] mx-auto">
      <h2 className="text-2xl md:text-4xl font-semibold mb-10">RECOMMENDED FOR</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-8 max-w-6xl mx-auto">
        {recommendations.map((item, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-sm font-medium p-4 rounded-lg shadow-md bg-white hover:bg-orange-100 hover:scale-105 transition-all duration-300 ease-in-out cursor-pointer"
          >
            <div className="text-orange-700">{item.icon}</div>
            <span className="mt-2 text-center">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Recommendations;
